<div class="modal-container">

  <div class="modal-icon">
    <mat-icon>lock</mat-icon>
  </div>

  <h2 class="modal-title">Acesso bloqueado</h2>

  <p class="modal-mensagem">{{ mensagem }}</p>

  <div class="modal-contador">
    <span>Você será desconectado em</span>
    <strong>{{ contador }}s</strong>
  </div>

  <div class="modal-actions">
    <button mat-flat-button class="btn-logout" (click)="sair()">
      <mat-icon>logout</mat-icon>
      Sair agora
    </button>
  </div>

</div>
